module.exports = __webpack_public_path__ + "media/stylesheets/images/talentz/sec_change_img01-875db7f5ff4924799a1fa8e5d7891e2a.svg";